export const FETCH_MICRO_DATA_REQUEST = 'FETCH_MICTO_DATA_REQUEST';
export const FETCH_MICRO_DATA_SUCCESS = 'FETCH_MICTO_DATA_SUCCESS';
export const FETCH_MICRO_DATA_FAILURE = 'FETCH_MICTO_DATA_FAILURE';
export const FETCH_MICRO_DATA_UNMOUNT = 'FETCH_MICTO_DATA_UNMOUNT';